export const FETCH_BOOKS = "getBooks";
export const FETCH_SECTIONS = "fetchSections";
export const SAVE_RECORDING = "saveRecording";
export const SET_RECORDING_ID_AND_GUID = "setRecordingIdAndGuid";
export const ADD_TUTOR_LINK_TO_RECORDING = "addTutorLinkToRecording";
export const DELETE_RECORDING = "deleteRecording";
export const ADD_RECORDING_TO_TARGET = "addRecordingToTarget";
export const ADD_SPELLING_TO_TARGET = "addSpellingToTarget";
export const SET_TARGET = "setTarget";
export const UPDATE_TARGET = "updateTarget";
